import { render, staticRenderFns } from "./MatchRecoverSecret.vue?vue&type=template&id=de67804a&"
import script from "./MatchRecoverSecret.vue?vue&type=script&lang=js&"
export * from "./MatchRecoverSecret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports